import { render, staticRenderFns } from "./creatRoom.vue?vue&type=template&id=2cf9cbc1&scoped=true"
import script from "./creatRoom.vue?vue&type=script&lang=js"
export * from "./creatRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9cbc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf9cbc1')) {
      api.createRecord('2cf9cbc1', component.options)
    } else {
      api.reload('2cf9cbc1', component.options)
    }
    module.hot.accept("./creatRoom.vue?vue&type=template&id=2cf9cbc1&scoped=true", function () {
      api.rerender('2cf9cbc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/room/creatRoom.vue"
export default component.exports